import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Sheet,
  SheetBody,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import clsx from "clsx"
import { ReactNode } from "react"

type Props = {
  contentClassName?: string
  bodyClassName?: string
  header?: ReactNode
  body?: ReactNode
  sheetSideToOpen?: "bottom" | "left" | "right" | "top" | null
  sheetHeight?: number
  open: boolean
  closeWhenInteractOutside?: boolean
  handleClose: () => void
}

const AdaptiveDialogAndSheet = ({
  contentClassName,
  bodyClassName,
  sheetSideToOpen = "bottom",
  sheetHeight = 90,
  closeWhenInteractOutside,
  header,
  body,
  open,
  handleClose,
}: Props) => {
  const isSmDown = useMediaQuery("only screen and (max-width : 640px)")

  if (isSmDown)
    return (
      <Sheet open={open} onOpenChange={handleClose}>
        <SheetContent
          closeWhenInteractOutside={closeWhenInteractOutside}
          className={clsx(contentClassName, "rounded-b-none")}
          side={sheetSideToOpen}
          height={sheetHeight}
        >
          <SheetTitle className="hidden" />
          {header && <SheetHeader>{header}</SheetHeader>}
          {body && <SheetBody className={bodyClassName}>{body}</SheetBody>}
        </SheetContent>
      </Sheet>
    )

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent
        className={contentClassName}
        {...(closeWhenInteractOutside && { closeWhenInteractOutside })}
      >
        <DialogTitle className="hidden" />
        {header && <DialogHeader>{header}</DialogHeader>}
        {body && <DialogBody className={bodyClassName}>{body}</DialogBody>}
      </DialogContent>
    </Dialog>
  )
}

export default AdaptiveDialogAndSheet
